/* eslint-disable sort-keys-fix/sort-keys-fix */
import { tv } from 'tailwind-variants';

export const buttonStyles = tv({
  base: [
    'focus-visible:focus-outline',
    'flex items-center justify-center rounded-large px-6',
    'cursor-pointer overflow-hidden border border-solid text-center transition-[opacity,border-color,background-color] ease-in-out body-6',
  ],
  variants: {
    color: {
      primary: 'border-neutral-20 bg-neutral-20',
      secondary: 'border-none text-neutral-20',
      danger: 'border-none',
    },
    isActive: {
      true: '',
    },
    variant: {
      solid: '',
      flat: '',
      ghost: '',
      text: 'p-0 body-5',
      bordered: '',
    },
    size: {
      small: 'h-6 gap-2 px-4',
      medium: 'h-8 gap-2',
      large: 'h-10 gap-2',
    },
    isDisabled: {
      true: 'cursor-not-allowed',
    },
    isLoading: {
      true: 'cursor-not-allowed',
    },
    fluid: {
      true: 'w-full',
    },
    hasIconOnly: {
      true: 'p-0',
    },
    hasChevron: {
      true: '',
    },
    hasChevronOnly: {
      true: '',
    },
  },
  compoundVariants: [
    // primary
    {
      color: 'primary',
      variant: 'solid',
      className: 'text-white hover:border-neutral-40 hover:bg-neutral-40',
    },
    {
      color: 'primary',
      variant: 'solid',
      isDisabled: true,
      className: 'border-neutral-80 bg-neutral-80 text-white hover:border-neutral-80 hover:bg-neutral-80',
    },
    {
      color: 'primary',
      variant: 'solid',
      isLoading: true,
      className: 'hover:bg-neutral-20',
    },
    // secondary
    {
      color: 'secondary',
      variant: 'solid',
      className: 'bg-white hover:bg-neutral-96',
    },
    {
      color: 'secondary',
      variant: 'bordered',
      className: 'border border-solid border-neutral-90 hover:border-neutral-80',
    },
    {
      color: 'secondary',
      variant: 'flat',
      className: 'bg-neutral-98 hover:bg-neutral-96',
    },
    {
      color: 'secondary',
      variant: 'text',
      className: 'gap-1 bg-none normal-case hover:text-neutral-40',
    },
    {
      color: 'secondary',
      variant: 'ghost',
      className: 'hover:bg-neutral-98',
    },
    {
      color: 'secondary',
      isDisabled: true,
      variant: 'solid',
      className: 'bg-neutral-96',
    },
    {
      color: 'secondary',
      isDisabled: true,
      variant: 'ghost',
      className: 'text-neutral-60 hover:bg-transparent',
    },
    {
      color: 'secondary',
      isDisabled: true,
      variant: 'bordered',
      className: 'text-neutral-60',
    },
    {
      color: 'secondary',
      isActive: true,
      className: 'border border-solid border-neutral-40',
    },
    // danger
    {
      color: 'danger',
      variant: 'solid',
      className: 'bg-error-45 text-white hover:opacity-70',
    },
    {
      color: 'danger',
      variant: 'text',
      className: 'text-error-45 hover:opacity-70',
    },
    {
      color: 'danger',
      variant: ['solid', 'text'],
      isDisabled: true,
      className: 'opacity-40',
    },
    {
      color: 'danger',
      variant: 'solid',
      isDisabled: true,
      className: 'border-neutral-80',
    },
    // other
    {
      hasIconOnly: false,
      className: 'pl-5',
    },
    {
      hasIconOnly: false,
      size: 'small',
      className: 'pl-3',
    },
    {
      hasChevron: true,
      className: 'pr-3',
    },
    {
      hasIconOnly: true,
      hasChevron: false,
      className: 'shrink-0 p-0',
    },
    {
      hasIconOnly: true,
      hasChevron: false,
      size: 'large',
      className: 'w-10',
    },
    {
      hasIconOnly: true,
      size: 'large',
      hasChevron: true,
      className: 'pl-4 pr-3',
    },
    {
      hasIconOnly: true,
      size: 'medium',
      hasChevron: true,
      className: 'pl-3 pr-2',
    },
    {
      hasIconOnly: true,
      size: 'small',
      hasChevron: true,
      className: 'pl-2 pr-1',
    },
    {
      hasChevronOnly: true,
      size: 'large',
      className: 'w-10 p-0',
    },
    {
      hasChevronOnly: true,
      size: 'small',
      className: 'w-6 p-0',
    },
    {
      hasChevronOnly: true,
      size: 'medium',
      className: 'p-2',
    },
    {
      hasIconOnly: true,
      size: 'small',
      className: 'p-1',
    },
    {
      hasIconOnly: true,
      hasChevron: false,
      size: 'small',
      className: 'w-6',
    },
    {
      hasIconOnly: true,
      hasChevron: false,
      size: 'medium',
      className: 'w-8 p-2',
    },
    {
      hasIconOnly: true,
      variant: 'text',
      className: 'h-5 w-5',
    },
    {
      hasIconOnly: true,
      hasChevron: true,
      className: 'gap-1 pl-2',
    },
    {
      size: ['medium', 'large'],
      variant: 'text',
      className: 'h-5',
    },
    {
      variant: 'text',
      hasChevronOnly: true,
      className: 'w-5',
    },
  ],
});
